import React from 'react';
import './Loading.css'

export const Loading = (props) => (
    <div className="loading" />
);
